import request from '@/utils/request';

export async function selBaseInfoById(params) {
  return request.post('/api/pdmg/base/info/selById', { ...params });
}

export async function selBaseInfoTraceByParamNoLogin(params) {
  return request.post('/api/pdmg/base/info/selBaseInfoTraceByParamNoLogin', { ...params });
}

export async function selBaseInfoTraceByRecordEntryTypeNoLogin(params) {
  return request.post('/api/pdmg/base/info/selBaseInfoTraceByRecordEntryTypeNoLogin', { ...params });
}

export async function selBaseInfoYears(params) {
  return request.post('/api/bigdata/selBaseInfoYears', { ...params });
}

export async function selBaseInfoSingle(params) {
  return request.post('/api/bigdata/selBaseInfoSingle', { ...params });
}

export async function selManageManufacturerBaseInfo(params) {
  return request.post('/api/bigdata/selManageManufacturerBaseInfo', { ...params });
}

export async function selHdfDtlDistribution(params) {
  return request.post('/api/satelite/sateliteHdfDtl/selHdfDtlDistribution', { ...params });
}

export async function getLngAndlatToArea(params) {
  return request.post('/api/system/area/getLngAndlatToArea', { ...params });
}

export async function selBusinessListByParam(params) {
  return request.post('/api/system/area/business/selListByParam', { ...params });
}

export async function selAreaListByName(params) {
  return request.post('/api/system/area/selAreaListByName', { ...params });
}

